<template>
  <div class="shop-filter-wrap">
    <div :class="$options.name">
      <Field v-model="shop.search"
        class="shop-filter__search"
        type="search"
        size="sm"
        placeholder="Otsi tooteid..."
        @update:model-value="onSearchInput" />
      <Field v-model="shop.brandId"
        type="select"
        class="shop-filter__brand"
        size="sm"
        icon="fa-solid fa-industry"
        placeholder="Kõik brändid"
        :options="shop.brands"
        label-key="name"
        value-key="id"
        @update:model-value="setQuery({ brand: shop.brandId || undefined })" />
      <div class="shop-filter__price">
        <Field v-model="shop.priceMin"
          type="price"
          size="sm"
          icon=""
          placeholder="alates"
          @update:model-value="onPriceInput" />
        <span>–</span>
        <Field v-model="shop.priceMax"
          type="price"
          size="sm"
          icon=""
          placeholder="kuni"
          @update:model-value="onPriceInput" />
      </div>
      <Field v-if="auth.isLoggedIn"
        v-model="shop.showInactive"
        type="checkbox"
        label="Näita mitteaktiivseid"
        size="sm"
        label-side
        class="shop-filter__inactive"
        @update:model-value="setQuery({}); shop.applyFilters()" />
    </div>
    <SpecFilters :facets="shop.facets"
      :selected="shop.specs"
      @change="(id, values) => setQuery({ ['s' + id]: values.length ? values.join('|') : undefined })"
      @clear="clearSpecs" />
  </div>
</template>

<script>
import { useShopStore } from '@/stores/shop'
import { useAuthStore } from '@/stores/auth'
import SpecFilters from './spec-filters.vue'

export default {
  name: 'shop-filter',
  components: { SpecFilters },
  data() {
    return {
      shop: useShopStore(),
      auth: useAuthStore(),
      searchTimeout: null,
      priceTimeout: null
    }
  },
  methods: {
    onSearchInput() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.setQuery({ q: this.shop.search.trim() || undefined })
      }, 600)
    },
    onPriceInput() {
      const bound = (v) => (Number(v) > 0 ? Number(v) : undefined)
      clearTimeout(this.priceTimeout)
      this.priceTimeout = setTimeout(() => {
        this.setQuery({ min: bound(this.shop.priceMin), max: bound(this.shop.priceMax) })
      }, 600)
    },
    clearSpecs() {
      this.setQuery(Object.fromEntries(Object.keys(this.$route.query).filter((k) => /^s\d+$/.test(k)).map((k) => [k, undefined])))
    },
    // The shop page reads the list state from the URL; a new search starts at page 1.
    setQuery(change) {
      const query = { ...this.$route.query, ...change, lk: undefined }
      for (const k of Object.keys(query)) if (query[k] === undefined || query[k] === null) delete query[k]
      this.$router.replace({ query })
    }
  },
  beforeUnmount() {
    clearTimeout(this.searchTimeout)
    clearTimeout(this.priceTimeout)
  }
}
</script>

<style lang="scss" scoped>
.shop-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 12rem;
  margin-bottom: 24rem;
  align-items: center;
}

.shop-filter__search {
  flex: 1;
  max-width: 320rem;
}

.shop-filter__brand {
  width: 200rem;
}

.shop-filter__price {
  display: flex;
  align-items: center;
  gap: 6rem;
  color: #9aa6ae;

  > * {
    width: 120rem;
  }

  > span {
    width: auto;
  }
}

</style>
